import { toast } from "react-toastify";
import { DemoDataMode, DemoDataResult, DemoDataStatus } from "models/demo-data";

// No toast on failure: this runs on every page for admins, and a disabled/unavailable
// demo feature simply hides the button.
export const getDemoDataStatus = async (): Promise<DemoDataStatus | null> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/demo-data/status`, {
            credentials: 'include',
            method: 'GET',
        });
        if (!res.ok) return null;

        const data = await res.json();
        return data.data as DemoDataStatus;
    } catch {
        return null;
    }
}

export const createDemoData = async (
    moduleKey: string,
    mode: DemoDataMode,
    count: number
): Promise<DemoDataResult | null> => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/demo-data/${moduleKey}`, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({ mode, count }),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        toast.success("Demo data created.");
        return data.data as DemoDataResult;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating demo data");
        return null;
    }
}
